import React from "react";
import onClickOutside from "react-onclickoutside";

import CircleGraph from "../../../components/graphs/CircleFillGraph";
import { DropDownButton } from "../../../components/StyledComponents";
import SmallDropdownIcon from "../../../components/icons/DropdownSmall";
import {
  DropdownGraphContainer1,
  FirstDropdownGraph,
  CircleDetail,
  DropdownGraphChild
} from "./styles";

const ChannelsDropdown = ({
  dropDownTwoOpen,
  dropDownOneOpen,
  data,
  handleClick,
  handleDropdown
}) => {
  ChannelsDropdown.handleClickOutside = () =>
    handleDropdown("dropDownOneOutside");

  return (
    <div>
      <DropDownButton
        open={dropDownOneOpen}
        onClick={() => handleDropdown("dropDownOneOpen")}
        outlined={!dropDownOneOpen}
      >
        <SmallDropdownIcon open={dropDownOneOpen} />
        <span>تقييم انواع القنوات</span>
      </DropDownButton>

      {!dropDownTwoOpen && dropDownOneOpen && (
        <DropdownGraphContainer1>
          {data.map((item, i) => (
            <DropdownGraphChild
              key={i}
              onClick={() => handleClick(item.id, "dropDownData1")}
              selected={item.selected}
            >
              <FirstDropdownGraph>
                <CircleGraph value={item.value} title={item.name} />
              </FirstDropdownGraph>

              <CircleDetail size="large">{item.name}</CircleDetail>
            </DropdownGraphChild>
          ))}
        </DropdownGraphContainer1>
      )}
    </div>
  );
};

const clickOutsideConfig = {
  handleClickOutside: () => ChannelsDropdown.handleClickOutside
};

export default onClickOutside(ChannelsDropdown, clickOutsideConfig);
